import { render, staticRenderFns } from "./StockVSReorder.vue?vue&type=template&id=0635cff1"
import script from "./StockVSReorder.vue?vue&type=script&lang=js"
export * from "./StockVSReorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports